module.exports = __webpack_public_path__ + "static/media/get-started-info.9064024b.svg";